import type { BoothData } from "~/types/booth"
import { readXlsxFile } from "./xlsx"

export function toBooth(org: string, data: Record<string, unknown>) {
  const booth: Record<keyof BoothData, unknown> = {
    "祭典名": org,
    "No.": data["No."],
    "団体名": data["団体名"] || "",
    "企画名": data["企画名"] || "",
    "概要": data["概要"],
    "分類": data["分類"],
    "建物名": data["建物名"] || "",
    "部屋・フロア": (data["部屋・フロア"] as string || "").replace(/詳細は模擬店ページ.+/, ""),
    "時間(土曜)": (data["実施日時"] as string || "").match(/(?<=\(土\): ).+/)?.[0] ?? "×",
    "時間(日曜)": (data["実施日時"] as string || "").match(/(?<=\(日\):).+/)?.[0] ?? "×",
    "ID": org + "-" + data["No."],
  }
  return booth as BoothData
}

export async function getBooths(org: string) {
  const records = await readXlsxFile(`/data/booth/${org}.xlsx`)
  return records.map((data) => toBooth(org, data))
}
